var map = {
	"./chocolate-fictional/compliance_certifications.json": [
		8412,
		[
			8412
		]
	],
	"./chocolate/compliance_certifications.json": [
		448,
		[
			448
		]
	],
	"./hemas-clogard/compliance_certifications.json": [
		1555,
		[
			1555
		]
	],
	"./linqOne/compliance_certifications.json": [
		8544,
		[
			8544
		]
	],
	"./munchee-tikiri-marie/compliance_certifications.json": [
		9424,
		[
			7043
		]
	],
	"./shan-teas/compliance_certifications.json": [
		4110,
		[
			4110
		]
	],
	"./wipotech-chocolates/compliance_certifications.json": [
		133,
		[
			133
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1877;
module.exports = webpackAsyncContext;